type TUserFields = {
  first_name?: string
  last_name?: string
}
export const userFullName = ({ first_name, last_name }: TUserFields) => `${first_name} ${last_name}`
